import React from "react";
import { CONTACT } from "../mock";

const WhatsApp = () => {
  return (
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-white/20 hover:scale-110 hover:shadow-[0_6px_24px_rgba(37,211,102,0.45)] transition-[transform,box-shadow] duration-300"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#FFFFFF" aria-hidden="true">
        <path d="M16.004 3C8.832 3 3 8.83 3 16.002c0 2.292.6 4.53 1.74 6.502L3 29l6.66-1.746a12.98 12.98 0 0 0 6.34 1.652h.006C23.176 28.906 29 23.076 29 15.904 29 8.732 23.176 3 16.004 3zm0 23.734h-.004a10.77 10.77 0 0 1-5.49-1.504l-.394-.234-3.952 1.036 1.056-3.856-.258-.396a10.72 10.72 0 0 1-1.646-5.776c0-5.94 4.836-10.772 10.782-10.772 2.878 0 5.584 1.122 7.618 3.158a10.7 10.7 0 0 1 3.152 7.62c-.002 5.94-4.838 10.724-10.864 10.724zm5.924-8.062c-.324-.162-1.918-.946-2.216-1.054-.298-.108-.514-.162-.73.162-.216.324-.838 1.054-1.028 1.27-.19.216-.378.244-.702.082-.324-.162-1.368-.504-2.606-1.608-.964-.86-1.614-1.922-1.804-2.246-.188-.324-.02-.5.142-.66.146-.146.324-.378.486-.568.162-.19.216-.324.324-.54.108-.216.054-.406-.028-.568-.08-.162-.73-1.756-1-2.406-.262-.63-.53-.544-.73-.554-.188-.01-.406-.012-.622-.012a1.2 1.2 0 0 0-.866.406c-.298.324-1.136 1.11-1.136 2.704 0 1.594 1.162 3.134 1.324 3.35.162.216 2.286 3.49 5.538 4.894.774.334 1.378.532 1.848.682.776.246 1.482.212 2.04.128.622-.092 1.918-.784 2.188-1.54.27-.758.27-1.406.19-1.54-.082-.136-.298-.218-.622-.38z" />
      </svg>
    </a>
  );
};

export default WhatsApp;
